import { Autocomplete, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import SupplierService from "../../services/supplier.service";
import {
  FORNECEDOR_A_DEFINIR_ID,
  FORNECEDOR_A_DEFINIR_NAME,
} from "./domain/draft";

type SupplierOption = {
  _id: string;
  name: string;
};

const A_DEFINIR: SupplierOption = {
  _id: FORNECEDOR_A_DEFINIR_ID,
  name: FORNECEDOR_A_DEFINIR_NAME,
};

type SupplierFieldProps = {
  draftId: string;
  supplierId: string;
  supplierName: string;
  warn: boolean;
  label: string;
  onSelect: (id: string, name: string) => void;
};

export default function SupplierField({
  draftId,
  supplierId,
  supplierName,
  warn,
  label,
  onSelect,
}: SupplierFieldProps) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const { data, isLoading } = useQuery(
    ["estudo-verba-suppliers", search],
    () =>
      SupplierService.search({
        page: 0,
        pageSize: 20,
        order: "asc",
        sortField: "name",
        search,
        origin: "",
      }),
    { enabled: open, staleTime: 30_000 }
  );

  const options = useMemo(() => {
    const found = (data?.providers || []) as SupplierOption[];
    const rest = found.filter(
      (option) => option._id && option._id !== A_DEFINIR._id
    );
    const selected =
      supplierId && supplierId !== A_DEFINIR._id
        ? { _id: supplierId, name: supplierName || supplierId }
        : null;
    const list = [A_DEFINIR, ...rest];
    if (selected && !list.some((option) => option._id === selected._id)) {
      list.unshift(selected);
    }
    return list;
  }, [data, supplierId, supplierName]);

  const value: SupplierOption =
    !supplierId || supplierId === FORNECEDOR_A_DEFINIR_ID
      ? A_DEFINIR
      : { _id: supplierId, name: supplierName || supplierId };

  return (
    <Autocomplete
      size="small"
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      options={options}
      loading={isLoading}
      value={value}
      inputValue={open ? search : value.name}
      onInputChange={(_event, next, reason) => {
        if (reason === "reset") return;
        setSearch(next);
      }}
      filterOptions={(listed) => listed}
      isOptionEqualToValue={(option, selected) => option._id === selected._id}
      getOptionLabel={(option) => option.name || ""}
      onChange={(_event, next) => {
        if (!next) {
          onSelect(A_DEFINIR._id, A_DEFINIR.name);
          return;
        }
        onSelect(next._id, next.name);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Fornecedor"
          inputProps={{
            ...params.inputProps,
            "aria-label": label,
            "data-draft-id": draftId,
            "data-draft-field": "forn",
          }}
          sx={{
            "& .MuiInputBase-root": {
              height: 34,
              background: warn ? "#fff9ee" : "#fff",
              fontSize: 13,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: warn ? "#c77700" : "#bcc8d8",
            },
          }}
        />
      )}
    />
  );
}
